module.exports = __webpack_public_path__ + "static/media/Garage1.c843d819.jpg";